import store from "../store/index.js";
let formatDate = (date, time_zone) => {
  if (!date) {
    return "UNKNOWN";
  }
  if (typeof date === "object") {
    return date.toLocaleDateString("lookup", {
      day: "numeric",
      year: "numeric",
      month: "long",
      timeZone: time_zone,
    });
  } else if (typeof date === "number") {
    return new Date(date).toLocaleString("lookup", {
      day: "numeric",
      year: "numeric",
      month: "long",
      hour: "2-digit",
      minute: "2-digit",

      timeZone: time_zone,
    });
  } else if (date.includes("T")) {
    return new Date(date).toLocaleDateString("lookup", {
      day: "numeric",
      year: "numeric",
      month: "long",

      timeZone: time_zone,
    });
  } else {
    return new Date(date).toLocaleDateString("lookup", {
      day: "numeric",
      year: "numeric",
      month: "long",

      timeZone: time_zone,
    });
  }
};
let formatTime = (date, time_zone) => {
  if (!date) {
    return "00:00";
  }
  let params = {
    hour: "2-digit",
    minute: "2-digit",
  };

  if (time_zone) {
    params.timeZone = time_zone;
  }
  if (typeof date === "object") {
    return date.toLocaleString("lookup", params);
  } else if (date.includes("T")) {
    return new Date(date).toLocaleString("lookup", params);
  }
};
let formatPhoneNumber = (num) => {
  var cleaned = ("" + num).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return num;
};
let calculateEventTime = (event) => {
  let timestamp = (time) => {
    if (typeof time === "object") {
      return time / (60 * 60 * 1000);
    } else if (time.includes("T")) {
      return Date.parse(time) / (60 * 60 * 1000);
    }
  };
  switch (event.api_version) {
    case "9-28-2022":
      return timestamp(event.end_time) - timestamp(event.start_time);
    default:
      // todo : find any and all locations where this is used and ensure working
      // for pre-api-version legacy events
      return timestamp(event.data.endTime) - timestamp(event.data.startTime);
  }
};
let productTotal = (product, event) => {
  switch (event.api_version) {
    case "9-28-2022":
      if (product.type == "Package" || product.type == "Service") {
        let hours = calculateEventTime(event);
        let overage = hours - product.pricing.baseTime;
        if (product.priceOption === "Flat") {
          return product.pricing.baseRate;
        } else {
          return product.pricing.baseRate + product.pricing.addHourly * overage;
        }
      }
      if (product.type === "Add-On") {
        return product.pricing.units * product.pricing.unitRate;
      }
      break;
    default:
      if (product.type === "Package" || product.type === "Service") {
        let hours = calculateEventTime(event);
        let overage = hours - product.pricing.baseTime;
        if (product.priceOption === "Flat") {
          return product.pricing.baseRate;
        } else {
          return (
            Number(product.pricing.baseRate) +
            Number(product.pricing.addHourly) * Number(overage)
          );
        }
      }
      if (product.type === "Add-On") {
        return product.pricing.units * product.pricing.unitRate;
      }
      break;
  }
};
let subtotal = (event) => {
  let subtotal = 0;
  switch (event.api_version) {
    case "9-28-2022":
      for (let x = 0; x < event.invoice_products.length; x++) {
        subtotal += productTotal(event.invoice_products[x], event);
      }
      break;
    default:
      for (let x = 0; x < event.invoice.products.length; x++) {
        subtotal += productTotal(event.invoice.products[x], event);
      }
      break;
  }
  return subtotal;
};
let total = (event) => {
  let eventSubtotal = subtotal(event);
  switch (event.api_version) {
    case "9-28-2022":
      for (let x = 0; x < event.invoice_adjustments.length; x++) {
        let adjustment = event.invoice_adjustments[x];
        if (adjustment.type === "percentage") {
          if (adjustment.direction === "charge") {
            eventSubtotal += eventSubtotal * Math.abs(adjustment.amount);
          } else {
            eventSubtotal -= eventSubtotal * Math.abs(adjustment.amount);
          }
        }
        if (adjustment.type === "dollar") {
          if (adjustment.direction === "charge") {
            eventSubtotal = eventSubtotal + Math.abs(adjustment.amount);
          } else {
            eventSubtotal = eventSubtotal - Math.abs(adjustment.amount);
          }
        }
      }
      break;
    default:
      for (let x = 0; x < event.invoice.adjustments.length; x++) {
        let adjustment = event.invoice.adjustments[x];
        if (adjustment.type === "percentage") {
          if (adjustment.direction === "charge") {
            eventSubtotal += eventSubtotal * Math.abs(adjustment.amount);
          } else {
            eventSubtotal -= eventSubtotal * Math.abs(adjustment.amount);
          }
        }
        if (adjustment.type === "dollar") {
          if (adjustment.direction === "charge") {
            eventSubtotal = eventSubtotal + Math.abs(adjustment.amount);
          } else {
            eventSubtotal = eventSubtotal - Math.abs(adjustment.amount);
          }
        }
      }
      break;
  }
  return eventSubtotal;
};
let balanceOutstanding = (event) => {
  let balanceTotal = total(event);
  switch (event.api_version) {
    case "9-28-2022":
      if (event.invoice_payments.length > 0) {
        event.invoice_payments.forEach((element) => {
          if (element.amount) {
            balanceTotal -= element.amount;
          }
        });
      }
      break;
    default:
      if (event.invoice.payments.length > 0) {
        event.invoice.payments.forEach((element) => {
          if (element.amount) {
            balanceTotal -= element.amount;
          }
        });
      }
      break;
  }
  return balanceTotal;
};
let formatPrice = (n) => {
  let price = n / 100;
  return price.toLocaleString("lookup", {
    localeMatcher: "lookup",
    style: "currency",
    currency: store.getters.currencyCode,
  });
};
let finalPaymentDueDate = (event, finalPaymentSettings) => {
  let date;
  switch (event.api_version) {
    case "9-28-2022":
      date = event.date;
      break;
    default:
      date = event.data.date;
      break;
  }
  date = new Date(date);
  if (finalPaymentSettings.type === "weeks") {
    return new Date(
      date.setDate(date.getDate() - finalPaymentSettings.increment * 7)
    );
  } else if (finalPaymentSettings.type === "months") {
    return new Date(
      date.setMonth(date.getMonth() - finalPaymentSettings.increment)
    );
  } else if (finalPaymentSettings.type === "days") {
    return new Date(
      date.setDate(
        date.setDate(date.getDate() - finalPaymentSettings.increment)
      )
    );
  } else {
    return date;
  }
};

export {
  formatDate,
  formatTime,
  formatPhoneNumber,
  calculateEventTime,
  productTotal,
  subtotal,
  total,
  balanceOutstanding,
  formatPrice,
  finalPaymentDueDate,
};

export class Routers {
  static navigateToClientPage(id) {
    this.$router.push("contacts/clients/" + id);
  }
}
